import React from "react";
import styled from "styled-components";
import { Grid, Row, Col } from "react-bootstrap";

const DATA = [
  {
    question: "Where does IBorrowDesk get its data?",
    answer: [
      'All IBorrowDesk data is sourced from Interactive Brokers. You can check the source .csv files <a href="https://ibkr.info/article/2024" target="_blank">here</a>.',
      "It's important to understand that because IBorrowDesk only reports data from a single (albeit very large) brokerage, the fee and availability reported may be different at other brokerages.",
    ],
  },
  {
    question:
      "A stock I am following at IBorrowDesk has stopped reporting data. Is something broken?",
    answer: [
      'Unfortunately, if Interactive Brokers does not have any shares of a security available to borrow they will simply stop reporting any data at all instead of reporting "0". ' +
        "This can happen from time to time for hard to borrow securities. Usually someone returns some shares to Interactive Brokers, or a client makes additional shares available to borrow ensuring the security can be tracked again",
    ],
    id: "stopped-reporting",
  },
  {
    question: 'What does "fee" rate mean?',
    answer: [
      "A stock loan fee is the fee charged by a brokerage for borrowing shares. In IBorrowDesk's case, the fee rate is expressed as an annualized percentage charged by Interactive Brokers.",
    ],
    source: "https://www.investopedia.com/terms/s/stock-loan-fee.asp",
    id: "borrow-fee",
  },
  {
    question: 'What does "available" mean?',
    answer: [
      "In order to borrow shares from a brokerage (IBorrowDesk monitors Interactive Brokers), that brokerage needs shares available to lend out." +
        ' Typically these belong to other clients of the firm, or they could belong to Interactive Brokers itself. Liquid large cap securities are typically "easy" to borrow.' +
        " That is, brokerages have plenty of clients willing to lend out their shares. Some securities are in high demand - many people want to borrow them, or some may have restricted supply - few people willing to lend them." +
        ' In either case the "available" number can be low',
      'Matt levine (Bloomberg News) discusses an interesting case with <a href="https://www.iborrowdesk.com/report/NKLA">Nikola</a> where very few shares were available to borrow due to convertible arbitrage demand: <a href="https://www.bloomberg.com/opinion/articles/2020-07-21/people-loved-nikola-but-not-its-warrants+&cd=1&hl=en&ct=clnk&gl=ca&client=firefox-b-d">People Loved Nikola But Not Its Warrants</a>',
    ],
    source: "https://www.investopedia.com/terms/s/securitieslending.asp",
    id: "borrow-available",
  },
  {
    question:
      "A stock I am following doesn't have many shares available to borrow. Is that good or bad?",
    answer: [
      "Unfortunately all this means is there are a lot of market participants trying to borrow shares - and not many market participants are willing to lend shares. " +
        'Sometimes this can mean that a lot of short sellers take a dim view of the prospects of the company. Other times it can due to some technical restriction on trading: for example, a large issue of a publicly traded convertible bond that many bond-holders are trying to "hedge" by selling the security short.',
      "It's also worth noting that IBorrowDesk only tracks Interactive Brokers data - it could be that other brokerages have many shares available. Professional or institutional investors have access to data sources far more sophisticated than this site - which can only track a single, albeit very large and active, brokerage.",
    ],
    id: "tight-good-bad",
    source: "https://www.investopedia.com/terms/h/hardtoborrowlist.asp",
  },
];

const Question = styled.div`
  margin: 30px 0;
`;

const QandA = ({ id, question, answer, source }) => (
  <Question>
    <h4 id={id}>{question}</h4>
    {answer.map((paragraph, row) => (
      <p key={row} dangerouslySetInnerHTML={{ __html: paragraph }} />
    ))}
    {source != null ? (
      <p>
        <i>
          More info:{" "}
          <a href={source} target="_blank">
            {source}
          </a>
        </i>
      </p>
    ) : null}
  </Question>
);

export const FAQ = () => (
  <Grid>
    <Row>
      <Col xs={12} md={8} mdOffset={2}>
        {DATA.map((row) => (
          <QandA {...row} key={row.id} />
        ))}
      </Col>
    </Row>
  </Grid>
);
